import React, { useState } from "react";
import { toast } from "sonner";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(email)) {
      toast.error("Drop us a real email, partner.");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setEmail("");
      toast.success("You're on the list. Expect smoke signals soon.");
    }, 700);
  };

  return (
    <section
      id="subscribe"
      data-testid="newsletter-section"
      className="relative py-14 md:py-20 px-6 md:px-12 paper-bg text-vintage-ink overflow-hidden"
    >
      {/* Decorative top borders */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-vintage-ink" />
      <div className="absolute top-3 left-0 right-0 h-px bg-vintage-ink" />
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-vintage-ink" />
      <div className="absolute bottom-3 left-0 right-0 h-px bg-vintage-ink" />

      <div className="max-w-3xl mx-auto text-center relative">
        <p className="font-mono text-xs tracking-[0.35em] uppercase text-vintage-rust mb-6">
          / / Official Newsletter
        </p>

        <h2 className="font-heading text-5xl md:text-7xl uppercase text-vintage-ink tracking-wide leading-none mb-6">
          Stay In Touch
        </h2>

        <p className="font-subheading italic text-lg md:text-xl text-vintage-ink/80 mb-10 max-w-xl mx-auto">
          Tour announcements, early ticket access, behind-the-tape stories, and
          the occasional limited vinyl drop. No spam. Ever.
        </p>

        <form
          onSubmit={submit}
          data-testid="newsletter-form"
          className="flex flex-col sm:flex-row items-center gap-4 max-w-xl mx-auto"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="newsletter-input"
            className="flex-1 w-full bg-transparent border-b-2 border-vintage-ink text-vintage-ink text-xl py-3 px-2 focus:outline-none focus:border-vintage-rust placeholder-vintage-ink/40 font-body"
          />
          <button
            type="submit"
            data-testid="newsletter-submit-btn"
            disabled={loading}
            className="w-full sm:w-auto bg-vintage-ink text-vintage-paper font-heading text-xl tracking-[0.2em] px-8 py-3 hover:bg-vintage-rust transition-colors uppercase disabled:opacity-60"
          >
            {loading ? "Sending…" : "Subscribe"}
          </button>
        </form>

        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-vintage-ink/60 mt-8">
          ✦ Hand-stamped by the band, not by an algorithm ✦
        </p>
      </div>
    </section>
  );
}
